import { createSlice } from "@reduxjs/toolkit";
import { nanoid } from "nanoid";

const RevelationIframeSlice = createSlice({
  name: "revelation",
  initialState: {
    isFirstIframeRequest: true,
    currentIframeSrc: "",
    iFrameLoading: true,
    mimicUid: undefined as string,
    uniqueId: null as string,
  } as RevelationIframeType,
  reducers: {
    setIframeLoaded: (state, action) => {
      state.iFrameLoading = false
    },
    updateIframeSrc: (state, action) => {
      //console.log('state.currentIframeSrc=', state.currentIframeSrc, action.payload, state.currentIframeSrc === action.payload)
      console.log('updateIframeSrc - action.payload:', action.payload, state.currentIframeSrc === action.payload)
      state.iFrameLoading = true;//(state.currentIframeSrc !== action.payload)
      state.currentIframeSrc === action.payload
        ? state.currentIframeSrc = action.payload + (action.payload.indexOf("?") > -1 ? "&d=" : "?d=") + nanoid()
        : state.currentIframeSrc = action.payload;
      state.uniqueId = nanoid();
      //}
    },
    mimicUser: (state, action) => {
      state.mimicUid = action.payload;
      state.currentIframeSrc = null;
      state.iFrameLoading = true;
    },
    cancelMimic: (state) => {
      state.mimicUid = null;
      state.currentIframeSrc = null;
      state.iFrameLoading = true;
    },
    setFirstIframeRequest: (state, action) => {
      state.isFirstIframeRequest = action.payload;
    },
  },
});

export type RevelationIframeType = {
  iFrameLoading: boolean;
  currentIframeSrc: string;
  mimicUid: string;
  uniqueId: string;
  isFirstIframeRequest: boolean;
};

export const {
  updateIframeSrc,
  setIframeLoaded,
  mimicUser,
  cancelMimic,
  setFirstIframeRequest
} = RevelationIframeSlice.actions;
export default RevelationIframeSlice.reducer;
